import React from 'react'
import { Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { OrderStatuses } from '../../models'
import { HistoryStatusId } from '../../types'

interface OrderStatusProps {
  statusType: string | number
  statuses: OrderStatuses
}

const useStyles = makeStyles()(theme => ({
  orderText: {
    borderRadius: theme.shape.borderRadius,
    padding: `${theme.spacing(0)} ${theme.spacing(2)}`,
  },
  canceled: {
    color: theme.palette.error.main,
    backgroundColor: theme.palette.error.light,
  },
  closed: {
    color: theme.palette.grey.grey02,
    backgroundColor: theme.palette.grey.grey06,
  },
  normal: {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.light,
  },
}))

/*
 * This component renders the type of history status in the card, with different colors on different types
 */
const OrderStatus: React.FC<OrderStatusProps> = ({ statusType, statuses }) => {
  const { classes, cx } = useStyles()

  if (statusType === HistoryStatusId.Canceled) {
    return <Typography className={cx(classes.orderText, classes.canceled)}>{statuses[statusType]}</Typography>
  }

  if (statusType === HistoryStatusId.Closed) {
    return <Typography className={cx(classes.orderText, classes.closed)}>{statuses[statusType]}</Typography>
  }

  return <Typography className={cx(classes.orderText, classes.normal)}>{statuses[statusType]}</Typography>
}

export default OrderStatus
